import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { useAuth } from "@/hooks/use-auth";
import { isCurrentUserAdmin } from "@/lib/kg.admin.functions";

export function useIsAdmin() {
  const { user } = useAuth();
  const fn = useServerFn(isCurrentUserAdmin);
  const q = useQuery({
    queryKey: ["is-admin", user?.id ?? null],
    queryFn: () => fn(),
    enabled: Boolean(user),
    staleTime: 5 * 60_000,
  });
  return {
    isAdmin: q.data?.isAdmin ?? false,
    email: q.data?.email ?? null,
    loading: q.isLoading,
  };
}
